import { createContext, useContext } from 'react'
import type { MediaDeviceListenerValue } from './av-test-listener'

export const MediaDevicePreviewContext =
  createContext<MediaDeviceListenerValue | null>(null)

export function useMediaDevicePreview(): MediaDeviceListenerValue {
  const ctx = useContext(MediaDevicePreviewContext)
  if (!ctx) {
    throw new Error(
      'useMediaDevicePreview must be used within a MediaDevicePreviewProvider'
    )
  }
  return ctx
}
